import { useField } from 'formik';
import { FC, useMemo } from 'react';

import Form from '@controls/Form';

import { filterTitleStyles } from '../../../../../../styles';
import { getFieldName } from '../../../../../../utils';
import { sortFilterItems } from '../../../../../../utils/sortFilterItems';
import FilterFieldRenderer from '../../../../../FilterForm/components/FilterFieldRenderer';
import { containerStyles, titleStyles } from './styles';
import { BrandFilterItemProps } from './types';

const BrandFilterItem: FC<BrandFilterItemProps> = ({
    filterField,
    fieldPrefix,
    expandedFilters,
    toggleFilter,
    onFilterChange,
}) => {
    const brandItems = filterField.values || [];
    const fieldName = getFieldName(String(filterField.code), fieldPrefix);
    const [field] = useField<(string | number)[]>(fieldName);

    const sortedBrandItems = useMemo(() => {
        const selectedValues = field.value || [];

        return sortFilterItems(brandItems, selectedValues);
    }, [brandItems, field.value]);

    const sortedFilterField = useMemo(
        () => ({
            ...filterField,
            values: sortedBrandItems,
        }),
        [filterField, sortedBrandItems]
    );

    return (
        <div css={containerStyles}>
            <div
                css={{
                    ...filterTitleStyles,
                    ...titleStyles,
                }}
            >
                {filterField.name}
            </div>
            <Form.Field name={fieldName}>
                <FilterFieldRenderer
                    filterField={sortedFilterField}
                    expandedFilters={expandedFilters}
                    fieldPrefix={fieldPrefix}
                    onToggle={toggleFilter}
                    onFilterChange={(changedFieldName, newValue) => {
                        const valueToPass = newValue !== undefined ? newValue : field.value || [];
                        onFilterChange?.(changedFieldName, valueToPass);
                    }}
                />
            </Form.Field>
        </div>
    );
};

export default BrandFilterItem;
